import {Component, Input} from '@angular/core';
import {TooltipModule} from 'primeng/tooltip';

@Component({
  selector: 'app-nav-item',
  standalone: true,
  templateUrl: './main-nav-item.component.html',
  imports: [
    TooltipModule
  ],
  styleUrl: './main-nav-item.component.scss'
})

export class MainNavItemComponent {
  @Input() text!: string;
  @Input() icon!: string;
  @Input() isActive!: boolean;
  @Input() isReportGroup!: boolean;
}

